import queryString from 'query-string'
import { isArray } from 'lodash'
import defaultState from '../data'

export default (state, filtersList, parseUrl = false) => {

  let newState = { ...defaultState }

  if ( filtersList['ambiencesList'] ) {
    newState['filters']['ambiences']['list'] = filtersList['ambiencesList']
  }

  if ( filtersList['awardsList'] ) {
    newState['filters']['awards']['list'] = filtersList['awardsList']
  }

  if ( filtersList['cuisinesList'] ) {
    newState['filters']['cuisines']['list'] = filtersList['cuisinesList']
  }

  let newSelections = [...state.selections]

  if ( parseUrl ) {

    const params = queryString.parse(location.search, {arrayFormat: 'comma'})

    if (params['current_page']) {
      newState.page = params['current_page']
    }
    if (params['per_page']) {
      newState.per_page = params['per_page']
    }
    if (params['terms'] ) {
      newState.searchTerm = params['terms']
    }
    if (params['type']) {
      newState.searchType = params['type']
    }
    if ( params['style'] ) {
      const arr = isArray(params['style']) ? params['style'] : [params['style']]
      arr.map(param => {
        try {

          const filter = {
            'field': 'ambiences.description',
            'condition': 'eq',
            'value': param,
          }

          newSelections.push(filter)

        } catch {
            console.log('Wrong Style url parameter')
        }
      })
    }
    if ( params['cuisine'] ) {
      const arr = isArray(params['cuisine']) ? params['cuisine'] : [params['cuisine']]
      arr.map(param => {
        try {

          const filter = {
            'field': 'cuisines.description',
            'condition': 'eq',
            'value': param,
          }

          newSelections.push(filter)

        } catch {
            console.log('Wrong Cuisine url parameter')
        }
      })
    }
    if ( params['award'] ) {
      const arr = isArray(params['award']) ? params['award'] : [params['award']]
      arr.map(param => {
        try {
          let params = param.split('-')
          const value = params[1] ? params[1] : 0
          const filters = {
            filters: [
              {
                'field': 'awards.name',
                'condition': 'eq',
                'value': params[0],
              },
              {
                'field': 'awards.pivot.score',
                'condition': 'gte',
                'value': value,
              },
            ],
          }

          newSelections.push(filters)

        } catch {
            console.log('Wrong Awards url parameter')
        }
      })
    }
    if ( params['partySize'] ) {
      try {

        const param = params['partySize'].split('-')
        const minInputValue = parseFloat(param[0])
        const maxInputValue = parseFloat(param[1])

        if (isNaN(minInputValue) || isNaN(maxInputValue)) {
          throw 'Party size value is not a number'
        }

        const filters = {
          filters: [
            {
              'field': 'private_dining_rooms.min_capacity',
              'condition': 'gt',
              'value': minInputValue,
            },
            {
              'field': 'private_dining_rooms.max_capacity',
              'condition': 'lt',
              'value': maxInputValue,
            },
          ],
        }

        newSelections.push(filters)

      } catch {
          console.log('Wrong PartySize url parameter')
      }

    }

    if ( params['clubOffersTimes'] ) {
      const arr = isArray(params['clubOffersTimes']) ? params['clubOffersTimes'] : [params['clubOffersTimes']]
      arr.map(param => {
        try {
          const meal = param.charAt(0)
          const day = parseFloat(param.charAt(1))
          if (isNaN(day)) {
            throw 'Club offer day parameter is not a number'
          }
          let mealName = ''
          switch(meal.toUpperCase()) {
            case 'B':
              mealName = 'Breakfast'
              break;
            case 'L':
              mealName = 'Lunch'
              break;
            case 'A':
              mealName = 'Afternoon Tea'
              break;
            case 'D':
              mealName = 'Dinner'
              break;
          }

          const filters = {
            filters: [
              {
                'field': 'membership_validities.meal.name',
                'condition': 'eq',
                'value': mealName,
              },
              {
                'field': 'membership_validities.day_of_week',
                'condition': 'eq',
                'value': day,
              },
            ],
          }

          newSelections.push(filters)

        } catch {
            console.log('Wrong clubOffers url parameter')
        }
      })
    }

    if ( params['clubOffersOnly'] ) {
      const filter = {
        'field': 'limited_edition_bool',
        'condition': 'eq',
        'value': 1,
      }

      newSelections.push(filter)
    }

    if ( params['sort'] ) {
      const option = params['sort']
      newState.sortBy = option
      let orderObj

      if ( 'nameAsc' === option ) {
        orderObj = {
          'field': 'name',
          'method': 'asc',
        }
      }
      else if ( 'nameDesc' === option ) {
        orderObj = {
          'field': 'name',
          'method': 'desc',
        }
      }
      else if ( 'newest' === option ) {
        orderObj = {
          'field': 'venue_live',
          'method': 'desc',
        }
      }

      else if ( 'nearest' === option && newState.searchTerm) {
        orderObj = {
          'field': 'distance',
          'method': 'asc',
        }
      } else if ( 'farthest' === option && newState.searchTerm ) {
        orderObj = {
          'field': 'distance',
          'method': 'desc',
        }
      }
      else {
        orderObj = {
          'field': 'venue_live',
          'method': 'desc',
        }
      }

      newState.sorts = [
        orderObj,
      ]
    }

  }


  newState['selections'] = newSelections

  return newState

}
